export const insertListAds = ({ list, adConfig, skippedAds, listIndex, skip }) => {
  if (!list || !adConfig || skip) return list

  const { first, interval, adTemplate } = adConfig

  let index = 0
  const items = []

  if (listIndex) {
    skippedAds = skippedAds[listIndex] ?? {}
  }

  if (skippedAds[index]) {
    items.push(...list.items.slice(0, first + 1))
  } else {
    items.push(
      ...list.items.slice(0, first),
      { ...adTemplate, type: 'ad', slug: adSlug(adTemplate, index), index: index++, listIndex },
      ...list.items.slice(first, first + 1),
    )
  }

  if (!interval) {
    items.push(...list.items.slice(first + 1))
  } else {
    for (let i = first + 1; i < list.items.length; i++) {
      if ((i - first) % interval === 0) {
        if (!skippedAds[index]) {
          items.push({
            ...adTemplate,
            type: 'ad',
            slug: adSlug(adTemplate, index),
            index,
            listIndex,
          })
        }
        index++
      }
      items.push(list.items[i])
    }
  }

  return { ...list, items }
}

const adSlug = ({ zone, placement }, index) => `${zone}-${placement}-${index}`
